import React, { FC, PropsWithChildren } from 'react';

import { ThemeMode } from '@/helpers/enums';

import { ScrollBlockStyleProps, ScScrollBlock } from './styled';

export type ScrollBlockProps = ScrollBlockStyleProps & PropsWithChildren;

export const ScrollBlock: FC<ScrollBlockProps> = ({
  children,
  scrollTopMargin = 16,
  scrollBottomMargin = 16,
  mode = ThemeMode.Dark,
  ...props
}) => (
  <ScScrollBlock
    scrollTopMargin={scrollTopMargin}
    scrollBottomMargin={scrollBottomMargin}
    mode={mode}
    {...props}
  >
    <div className="scroll-element">{children}</div>
  </ScScrollBlock>
);
